<template>
  <div>
    <b-sidebar
      id="add-supir-sidebar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      :visible="addSupirSidebar"
      right
      no-header
      backdrop
      @hidden="(val) => changeValue(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5
            class="mb-0"
          >
            {{ supirLocal.id > 0 ? 'Edit Supir' : 'Add Supir' }}
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Body -->
        <validation-observer
          ref="simpleRules"
          class="px-2"
        >
          <b-form>
            <b-row class="px-2">
              <b-col md="12">
                <b-form-group
                  label="Nama"
                  label-for="supir-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Supir Name"
                    rules="required"
                  >
                    <b-form-input
                      id="supir-name"
                      v-model="supirLocal.name"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Nama Supir"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Email"
                  label-for="supir-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="supir-email"
                      v-model="supirLocal.email"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-show="supirLocal.id < 1"
                md="12"
              >
                <b-form-group
                  label="Password"
                  label-for="supir-password"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-form-input
                      id="supir-password"
                      v-model="supirLocal.password"
                      type="password"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Password"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="No Telepon"
                  label-for="supir-no-telepon"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="No Telepon"
                    rules="required"
                  >
                    <b-form-input
                      id="supir-no-telepon"
                      v-model="supirLocal.no_telp"
                      :state="errors.length > 0 ? false:null"
                      placeholder="No Telepon"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Status Supir"
                  label-for="status-supir"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status Supir"
                    rules="required"
                  >
                    <b-form-select
                      id="status-supir"
                      v-model="supirLocal.status_supir"
                      :options="optionsSupir"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Status Supir"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Status"
                  label-for="status-status"
                >
                  <b-form-select
                    id="status-status"
                    v-model="supirLocal.status"
                    :options="options"
                    placeholder="Status"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="supirLocal.id > 0 && supirLocal.foto"
                md="12"
              >
                <b-row>
                  <b-col md="12">
                    <label for="preview-image">Preview Foto Sebelumnya: </label>
                  </b-col>
                  <b-col md="12">
                    <b-img
                      id="preview-image"
                      class="mb-2"
                      width="200"
                      :src="supirLocal.foto"
                      fluid
                      alt="Preview Image"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Foto Supir"
                  label-for="foto-supir"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Foto Supir"
                    rules="required"
                  >
                    <b-form-file
                      id="foto-supir"
                      v-model="supirLocal.foto_supir"
                      accept="image/*"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Pilih File"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="submit()"
                >
                  Submit
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="changeValue(false)"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BCol,
  BRow, BSidebar, BFormSelect, BFormFile, BImg,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BCol,
    BRow,
    BSidebar,
    BFormSelect,
    BFormFile,
    BImg,
  },
  model: {
    prop: 'addSupirSidebar',
  },
  props: {
    addSupirSidebar: {
      type: Boolean,
      required: true,
    },
    supir: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      supirLocal: {
        id: null,
        name: null,
        email: null,
        password: null,
        no_telp: null,
        status_supir: null,
        status: null,
        foto: null,
      },
      optionsSupir: [
        { value: 'utama', text: 'Utama' },
        { value: 'cadangan', text: 'Cadangan' },
      ],
      options: [
        { value: 'tidak_aktif', text: 'Tidak Aktif' },
        { value: 'aktif', text: 'Aktif' },
      ],
    }
  },
  watch: {
    supir() {
      this.resetTaskLocal()
    },
  },
  methods: {
    resetTaskLocal() {
      this.supirLocal = {
        id: this.supir.id,
        name: this.supir.nama,
        email: this.supir.email,
        no_telp: this.supir.telp,
        status_supir: this.supir.statusSupir,
        status: this.supir.status,
        foto: this.supir.foto,
      }
    },
    changeValue() {
      const data = {
        id: null,
        name: '',
        email: '',
        password: '',
        no_telp: '',
        status_supir: '',
        status: 0,
      }
      this.$emit('supir-sidebar-change', data, false)
    },
    submit() {
      if (this.supirLocal.id > 0) {
        this.$emit('submit-data-supir', this.supirLocal)
      } else {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$emit('submit-data-supir', this.supirLocal)
          }
        })
      }
    },
  },
}
</script>
<style>
.b-sidebar-body {
  overflow: hidden !important;
}
</style>
